import { forwardRef, type Ref, type SVGProps } from "react";
const IconLockOpenOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M17 22.3V19a1 1 0 0 0-2 0v3.3a2 2 0 0 0-1 1.7 2 2 0 0 0 4 0 2 2 0 0 0-1-1.7"
    />
    <path
      fill="currentColor"
      d="M25 14H11V8a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4 1 1 0 0 0 2 0 6 6 0 0 0-6-6h-2a6 6 0 0 0-6 6v6H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2m0 14H7V16h18z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLockOpenOutlineSVG);
ForwardRef.displayName = "IconLockOpenOutline";
export { ForwardRef as IconLockOpenOutline };
